<template>
  <div class="wf-modal wf-download-modal" :class="'wf-modal-' + (open ? 'active' : 'inactive')">
    <div class="wf-modal-wrapper" v-if="open">
      <div class="wf-modal-content p-0 bg-white d-flex">
        <div class="p-4"> 
          <h5>{{ $resourceString["pdp.modal.download.header.title"] }}</h5>
            <p>{{ $resourceString["pdp.modal.download.header.subtitle"] }}</p>

            <a v-for="tab in tabs" :key="tab.name" 
              href='#' @click.prevent.stop="selectTab(tab)" 
              :class="['text-link d-block mb-2', selectedTab.name === tab.name ? 'active' : '']">
              <span class="png-icon png-icon-icons-glyph--k-play-carrot "></span> 
              {{tab.tabLinkText}}
            </a>
          <div class="download-tab-triangle"></div>
        </div>
        <div class="p-4 bg-light wf-download-image-modal-content">
          <wf-download-image-modal-tab-content
            :element="selectedTab"
            :is-room-scene="selectedTab.name == tabs[ROOMSCENE_TAB_INDEX].name"
            :is-installation="selectedTab.name == tabs[INSTALLATION_TAB_INDEX].name"
            :default-item="getDefaultItem(selectedTab.name, roomScene, installationMethod)"
            :key="`${selectedTab.name}-${roomScene.data.toString()}-${installationMethod.tricycleCode}`">

          </wf-download-image-modal-tab-content>
        </div>
        <div id="wf-download-modal-spiner" class="wf-modal-loader d-none">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <div class="text-secondary d-none modal-error-404">
          <div class="modal-error-content">
            <span class="png-icon png-icon-icons-glyph--red-close-sqr-fill ">
            </span><br>
            <span class=""> {{ $resourceString["pdp.modal.download.error"] }}</span>
          </div>
        </div>
        <button class="wf-modal-button-close btn button-full" type="button" @click="closeModal" style="right:0px">
          <span class="png-icon png-icon-icons-symbols--k-txtclose " aria-label="Close modal"></span>
        </button>
      </div>
    </div>
    <div class="wf-modal-lightbox" >
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import WFTabContent from './wf-download-image-modal-tab-content.vue';

export default {
  data() {
    return {
      tabs:[
        {
          name: 'swatch', 
          title: 'Download swatch tile variations',
          downloadBtnText: 'Download tile variations',
          tabLinkText:'Swatch Tile Variations',
          items: [],
        },
        {
          name: 'installation', 
          title: 'Tile Installation Method',
          downloadBtnText: 'Download installation method',
          tabLinkText:'Tile Installation Method',
          items: [],
        },
        {
          name: 'roomscene', 
          title: 'Room Views',
          downloadBtnText: 'Download room view',
          tabLinkText:'Room Views',
          items: [],
          showItemIndex: true,
        },
      ],
      selectedTab: null,
    }
  },
  created(){
    WFTabContent.$helpers = this.$helpers;
    this.initializeModal();
  },
  components: {
    'wf-download-image-modal-tab-content': WFTabContent
  },
  computed: {
    ...mapGetters({
      open: 'productDetail/openDownloadFileModal',
      sellingStyleNumber: 'productDetail/sellingStyleNumber',
      color: 'productDetail/color',
      installationMethod: 'productDetail/installationMethod',
      installationMethods: 'productDetail/installationMethods',
      roomScene: 'productDetail/roomScene',
      roomScenes: 'productDetail/roomScenes',
    }),
    installationMethodItems: function() {
      return this.installationMethods.map(i => ({ name: i.name, value: i.tricycleCode, currentRoomScene: this.roomScene }));
    },
    roomSceneItems: function() {
      return this.roomScenes.map(i => ({name: i.type, value: i.data, currentInstallation: this.installationMethod }));
    },
  },
  watch: {
    open: function () {
      this.initializeModal();
    }
  },
  methods: {
    initializeModal: function() {
      this.SWATCH_TAB_INDEX = 0;
      this.INSTALLATION_TAB_INDEX = 1;
      this.ROOMSCENE_TAB_INDEX = 2;

      this.initElement(this.tabs[this.SWATCH_TAB_INDEX], []);

      this.initElement(this.tabs[this.INSTALLATION_TAB_INDEX], this.installationMethodItems);

      this.initElement(this.tabs[this.ROOMSCENE_TAB_INDEX], this.roomSceneItems);
      
      this.selectedTab = this.tabs[this.SWATCH_TAB_INDEX];
    },
    closeModal: function(){
      this.setOpenDownloadFileModal(!this.open);
    },
    getDefaultItem(name, roomScene, installationMethod){
      if(name === this.tabs[this.INSTALLATION_TAB_INDEX].name)
      {
        return ({ name: this.installationMethod.name, value: installationMethod.tricycleCode, currentRoomScene: roomScene});
      }

      if(name === this.tabs[this.ROOMSCENE_TAB_INDEX].name)
      {
        return ({ name: roomScene.type, value: roomScene.data, currentInstallation: installationMethod });
      }

      return null;
    },
    ...mapActions({
      setOpenDownloadFileModal: 'productDetail/setOpenDownloadFileModal'
    }),

    initElement(element, items){
      element.items = items;
    },
    selectTab(tab){
      this.selectedTab = tab;
    },
  },
  
}
</script>